import { composeValidations, required, validatePattern, validateEmail } from 'common/forms/FormValidationHelper';
import { SUMMARY_PATTERN } from 'ui/layout/ReportIssue/components/constants';
import { phoneNumberValidator } from 'validations/phoneNumber';
import { validateEntity } from 'validations/utils';

/**
 * Validate customer information
 * @param {Object} customer
 * @param {import('./types').ReportIssueMetaValidation} meta
 */
const customerValidator = (customer, meta) =>
  validateEntity(
    {
      firstName: required,
      lastName: required,
      email: validateEmail,
      phoneNumber: (value) => phoneNumberValidator(value, meta, true),
    },
    customer,
    meta
  );

/**
 * Validate context information
 * @param {Object} context
 * @param {import('./types').ReportIssueMetaValidation} meta
 */
const contextValidator = (context, meta) => {
  const baseValidation = {
    type: required,
  };

  return validateEntity(baseValidation, context, meta);
};

/**
 * Validate issue information
 * @param {Object} issue
 * @param {import('./types').ReportIssueMetaValidation} meta
 */
const issueValidator = (issue, meta) =>
  validateEntity(
    {
      summary: composeValidations(required, validatePattern(SUMMARY_PATTERN)),
      description: required,
    },
    issue,
    meta
  );

/**
 * Validate the entire ReportIssue form
 * @param {Object} values - Form values
 * @param {import('./types').ReportIssueMetaValidation} meta
 */
export const validate = (values, { isManufacturer, ...meta }) => validateEntity(isManufacturer ? { ...CONFIG, dealerId: undefined } : CONFIG, values, meta);

const CONFIG = {
  customer: customerValidator,
  dealerId: required,
  context: contextValidator,
  issue: issueValidator,
};
